import { ILoanInfo, ILoanItem } from '@/types';
import { ButtonOutline } from '@/components/atoms';
import { LoanListItem } from '@/components/organisms';
import { ButtonWrapper, Wrapper } from './CollectLoan.styled';
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react';
import { Navigation, SwiperOptions } from 'swiper';
import { clickEventHandler, makeTwoDimensionalArray } from '@/helpers';
import { IntersectionObserver } from '@/components/common';
import { useCommonParams, useDeviceId, useLoading } from '@/hooks';
import { useCallback, useRef, useState } from 'react';
import { COMPONENT_TYPE } from '@/const';

const swiperSettings: SwiperOptions = {
  slidesPerView: 1,
  navigation: {
    nextEl: '.swiper-button-next-loan',
  },
  loop: true,
  autoHeight: true,
};

const CollectLoan = (props: ILoanInfo) => {
  const { ads = [] } = props;
  const [deviceId] = useDeviceId();
  const [activeIndex, setActiveIndex] = useState(1);
  const [, setLoading] = useLoading();
  const commonParams = useCommonParams();
  const swiperRef = useRef<SwiperRef>(null);

  const removeLcs = ads.filter((item: any) => item.lcsBanner === false); // 대출비교 배너 이동 리스트 제거
  const loanList = makeTwoDimensionalArray(removeLcs, 3);

  const handleClickLoan = useCallback(
    async (item: ILoanItem) => {
      await clickEventHandler({
        ...item,
        ...commonParams,
        setLoading,
        deviceId,
        componentName: COMPONENT_TYPE.LOAN,
      });
    },
    [commonParams, setLoading, deviceId],
  );

  const handleClickNextButton = () => {
    swiperRef.current && setActiveIndex(swiperRef.current.swiper.realIndex + 1);
  };

  return (
    <Wrapper>
      {removeLcs.length > 3 && (
        <>
          <Swiper
            modules={[Navigation]}
            ref={swiperRef}
            {...swiperSettings}
            onSlideChange={handleClickNextButton}
          >
            {loanList.map((swiperArrayItem: ILoanItem[], index) => (
              <SwiperSlide key={`collect-loan-${index}`}>
                {swiperArrayItem.map((item: ILoanItem, index: number) => (
                  <IntersectionObserver
                    key={`loan-item-${index}`}
                    page={commonParams.page}
                    {...item}
                    componentName={COMPONENT_TYPE.LOAN}
                  >
                    <LoanListItem {...item} onClick={() => handleClickLoan(item)} />
                  </IntersectionObserver>
                ))}
              </SwiperSlide>
            ))}
          </Swiper>
          <ButtonWrapper>
            <ButtonOutline className="swiper-button-next-loan" full onClick={handleClickNextButton}>
              다음보기 {activeIndex}/<span style={{ color: '#CCCCCC' }}>{loanList.length}</span>
            </ButtonOutline>
          </ButtonWrapper>
        </>
      )}
      {removeLcs.length <= 3 &&
        removeLcs.map((item, index) => (
          <IntersectionObserver
            key={`collect-loan-${index}`}
            {...item}
            componentName={COMPONENT_TYPE.LOAN}
          >
            <LoanListItem {...item} onClick={() => handleClickLoan(item)} />
          </IntersectionObserver>
        ))}
    </Wrapper>
  );
};

export default CollectLoan;
